import type { JiraFilters, SearchJiraProductType } from '@atlassian/search-client';

import type { ProductKeys } from '../../common/constants/products';
import { JiraProductProjectFilterKey } from '../filters/selected/utils';

// This function is used to get the Jira filters for the results count query
export const getJiraFiltersForResultsCountQuery: (
	jiraFilters: JiraFilters,
	availableProducts: ProductKeys[],
) => {
	projectFilter: {
		projectTypes: SearchJiraProductType[];
	};
	issueFilter: {
		projectARIs: string[];
		assigneeARIs: string[];
		watcherARIs: string[];
		issueTypeIDs: string[];
		reporterARIs?: string[];
		issueLabels?: string[];
		issueTypes?: string[];
		commenterARIs?: string[];
		statusCategories?: import('@atlassian/search-client').SearchIssueStatusCategory[];
	};
} = (jiraFilters: JiraFilters, availableProducts: ProductKeys[]) => {
	const allAvailableJiraProductTypes = Object.keys(JiraProductProjectFilterKey).reduce(
		(acc, productKey) => {
			const jiraProductKey = productKey as keyof typeof JiraProductProjectFilterKey;
			if (!availableProducts || availableProducts.includes(jiraProductKey as ProductKeys)) {
				acc.push(...JiraProductProjectFilterKey[jiraProductKey]);
			}
			return acc;
		},
		[] as SearchJiraProductType[],
	);

	return {
		...jiraFilters,
		projectFilter: {
			...jiraFilters.projectFilter,
			projectTypes: allAvailableJiraProductTypes,
		},
	};
};
